import { Injectable } from '@angular/core';

import { environment } from '@admin/src/environments/environment';

import { MemberProfilesService as CoreMemberProfilesService } from '@lib/core/services/member-profiles.service';

@Injectable({ providedIn: 'root' })
export class MemberProfilesService extends CoreMemberProfilesService {
  constructor() {
    super(environment.protectedApiUrl);
  }
}